import gql from 'graphql-tag';

export default gql`
  query filterBrandsRelatedToCategory($filter: FilterBrandsRelatedToCategoryInput, $pagination: Pagination) {
    filterBrandsRelatedToCategory(filter: $filter, pagination: $pagination) {
      totalPage
      totalResults
      data {
        id
        slug
        name
        description
        description_vi
        imageUrl
        createdAt
        updatedAt
        status
        groupName
        productCategories {
          id
          slug
          name
          activated
        }
      }
    }
  }
`;
